import * as StyledGlobalCSS from "../constants/common/StyledGlobalConstants";
import { Img } from "../constants/common/StyledGlobalConstants";
import AddContact from "./addContact/AddContact";
import styled from "styled-components";
import BellIcon from "../assets/images/bell.png";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";

export const CustomWrapper = styled.div`
  text-align: center;
  margin-top: 2rem;
`;
export const AddContactContainer = styled.div`
  display: flex;
  line-height: 20px;
  font-size: 14px;
  font-family: neue-haas-grotesk-text;
  font-weight: 400;
  justify-content: center;
  margin: 32px 0 0 0;
`;
export const AddContactButton = styled.div`
  margin: 0;
`;

const NoContactNotification = ({ refreshTableData, isAnyContactPending, contractAccountId, accountId, setNotificationBanner }) => {
  const [t] = useTranslation("manageInvoiceTranslation");
  return (
    <CustomWrapper>
      <Img src={BellIcon} width="100px" height="100px" alt="No_notification" style={{ cursor: "pointer" }}></Img>
      <StyledGlobalCSS.MediumText bold>{t("No recipients available")}</StyledGlobalCSS.MediumText>
      <StyledGlobalCSS.MediumText>{t("Adding at least one recipient will allow us to send your invoices by email.")}</StyledGlobalCSS.MediumText>
      <AddContactContainer>
        <AddContactButton>
          <AddContact
            refreshTableData={() => refreshTableData()}
            isAnyContactPending={isAnyContactPending}
            contractId={contractAccountId}
            accountId={accountId}
            addContactNotification={() =>
              setNotificationBanner((prevState) => ({
                ...prevState,
                show: true,
                type: "success",
                title: t(
                  "We’ve received your request. It will take 24 hours or less for the new recipient to be added. You cannot make changes during this time."
                ),
              }))
            }
          />
        </AddContactButton>
      </AddContactContainer>
    </CustomWrapper>
  );
};

NoContactNotification.propTypes = {
  refreshTableData: PropTypes.func.isRequired,
  isAnyContactPending: PropTypes.bool.isRequired,
  contractAccountId: PropTypes.string.isRequired,
  accountId: PropTypes.string.isRequired,
  setNotificationBanner: PropTypes.func.isRequired,
};

export default NoContactNotification;
